import { ExpandedSurvey, NotificationGroup, Root, TargetFieldRef } from "@aidkitorg/types/lib/survey";
import {
  DependencyMap,
  DependencyNode,
  DistroComponent,
  TRANSLATORS,
} from "@aidkitorg/types/lib/translation/questions";
import { buildPathMap } from "../ConfigSearch";

export function getDependencyMap(survey: Root & { __templates_expanded: true }): DependencyMap | { _error: string } {
  const map = new Map<TargetFieldRef, DependencyNode>();
  console.time("getDependencyMap elapsed time:");
  try {
    ((survey && Array.isArray(survey) ? survey : survey?.survey) ?? []).forEach(
      (collectionComponent) => {
        TRANSLATORS[collectionComponent.kind].calculateDependencies(
          collectionComponent as any,
          map
        );
      }
    );
  } catch (e) {
    console.error('Error calculating dependencies for component', e);
    return { _error: 'Error calculating dependencies for component' };
  } finally {
    console.timeEnd("getDependencyMap elapsed time:");
  }
  return map;
}

/**
 * Collects and returns any NotificationGroup notifs that depend (including transitively) on the provided targetField.
 * Only considers "formula" type dependencies, not content or conditionals.
 */
export function findAnyDownstreamNotifications(
  map: DependencyMap,
  startId: TargetFieldRef
) {
  // Nodes/fields we've seen already
  const visited = new Set<TargetFieldRef>();
  const downstreamNotifications: NotificationGroup[] = [];
  // Stack for depth-first-search
  const stack = [startId];
  while (stack.length > 0) {
    const currentId = stack.pop()!;
    // Skip if we’ve already visited
    if (!currentId || visited.has(currentId)) {
      continue;
    }
    visited.add(currentId);
    const currentNode = map.get(currentId);
    if (!currentNode) {
      continue;
    }
    if (
      currentNode.component &&
      currentNode.component.kind === "Notification"
    ) {
      downstreamNotifications.push(currentNode.component);
    }
    for (const children of currentNode.children) {
      if (children.type !== "formula") continue;
      // This likely indicates a misconfiguration in Distro
      if (!children.field) {
        const errorMsg = `Empty reference of type "${children.type}" found for ${currentId}${currentNode.component ? ' kind: "' + currentNode.component.kind + '"' : ""}`;
        console.warn(errorMsg);
        continue;
      }
      // Continue traversal if we haven’t seen the relation yet
      if (!visited.has(children.field)) {
        stack.push(children.field);
      }
    }
  }
  return downstreamNotifications;
}

/**
 *  Returns a map: targetField -> tree path to be used for scrolling to the component
 *  via findAndGoToComponent in ConfigSearch.tsx
 */
export function buildTargetFieldPathMap(
  components: DistroComponent[],
  map: Record<string, string[]> = {}
): Record<string, string[]> {
  return buildPathMap({
    components,
    map,
    handlePotentialTarget: (component, tree, map) => {
      if (component.kind !== 'Show Field' && ((component as any).targetField || (component as any).targetPrefix)) {
        map[(component as any).targetField || (component as any).targetPrefix] = tree;
      };
    },
  });
}
